import React from 'react';
import './SearchBar.scss';
import Input from '../Input';

import searchIcon from '../../images/search.svg';

const SearchBar = () => (
  <form
    class="search-side"
    role="search"
    action="https://veinsamotors.com"
    method="get"
  >
    <div className="searchbar">
      <Input type="search" placeholder="Buscar" name="s" />
      <button className="searchbar__search-button" type="submit">
        <img src={searchIcon} alt="Search" className="searchbar__search-icon" />
      </button>
    </div>
  </form>
);

export default SearchBar;
